export default {
  login: {
    txt1: "การตรวจสอบรหัสลับผู้เล่นในเกม",
    txt2: "โปรดใส่รหัสลับ",
    txt3: "ยืนยัน",
    txt4: "โปรดเลือกเซิร์ฟเวอร์",
    txt5: "โปรดเลือกตัวละคร",
    txt6: "ล็อกอิน",
    txt7: "ศูนย์ช่วยเหลือ",
  },
  nav: {
    txt1: "หน้าหลัก",
    txt2: "การถ่ายทอดสด",
    txt3: "ความคืบหน้า",
    txt4: "MVP",
    txt5: "ชมการแข่งขันรับรางวัล",
    txt6: "ลุ้นรับของที\nระลึก",
    txt7: "รางวัล",
    txt8: "Content Creator",
  },
  live: {
    txt1: "กำหนดการ",
    txt2: "ห้องถ่ายทอดสดอื่นๆ",
    txt3: "เวลา: ",
    txt4: "เนื้อหา: ",
    txt5: "เข้าสู่ห้องถ่ายทอดสด",
    txt6: "เวลา",
    txt7: "MATCH",
    txt8: "กรุณาเข้าสู่ระบบ",
  },
  process: {
    nav1: "อันดับการแข่งขันคะแนน ",
    nav2: "การแข่งขันแบบแพ้คัดออก",
    nav3: "อันดับคะแนนรวม",
    txt1: "อันดับ",
    txt2: "ชื่อทีม",
    txt3: "เซิร์ฟเวอร์",
    txt4: "คะแนน",
    txt5: "ดิวิชั่น",
    txt6: "สังหาร",
    list: ["ดิวิชั่น 1", "ดิวิชั่น 2", "ดิวิชั่น 3", "ดิวิชั่น 4"],
    img: require("@/assets/th-img.jpg"),
  },
  periphery: {
    time1: "2023/11/22",
    title1: "Giveaway #1: รอบรองชนะเลิศเกมที่ 1 - Gift Code I *2",
    time2: "2023/11/24",
    title2: "Giveaway #2: รอบรองชนะเลิศเกมที่ 2 - Gift Code II *2",
    time3: "2023/11/25",
    title3: "Giveaway #3:  ชิงแชมป์ - Gift Code *1",
    p1: "Wager Token",
    p2: "Diamond ",
    p3: "Guild Token Chest ",
    p4: "Large Zeny Chest ",
    p5: "Rare Card Coupon ",
    p6: "Refining & Enchanting Pack II",
  },
  mvp: {
    txt1: "คะแนนสูงสุดที่เคยได้รับ",
    txt2: "เซิร์ฟเวอร์",
    txt3: "ชื่อทีม",
    txt4: "ชื่อตัวละคร",
    txt5: "เลเวลของตัวละคร",
    txt6: "อาชีพ",
    txt7: "รอบคัดเลือก 32 ทีม",
    txt8: "รอบชิงชนะเลิศออฟไลน์",
  },
  task: {
    loginTip: "กรุณาเข้าสู่ระบบก่อนเพื่อทำภารกิจให้สำเร็จและรับรางวัล",
    reward830: "Delot Opt. Pack *10\nNebula Path Material *50",
    task830: "รับชมรวม 10 นาทีในวันที่ 30 ส.ค.",
    reward91: "Ash of Delot *300\n Nebula Path Material *50",
    task91: "รับชมรวม 10 นาทีในวันที่ 1 ก.ย.",
    reward92: "Precious Sigil Pack *10\n Nebula Path Material *100",
    task92: "รับชมรวม 10 นาทีในวันที่ 2 ก.ย.",
    reward94: "Soul Crystal Random Box III *3\nNebula Path Material *100",
    task94: "รับชมรวม 15 นาทีในวันที่ 4 ก.ย.",
    reward96: "Soul Crystal Random Box III *3\nNebula Path Material *100",
    task96: "รับชมรวม 15 นาทีในวันที่ 6 ก.ย.",
    reward98:
      "Soul Crystal Key III *1  Soul Crystal Key II *1\nFlawed Sigil Crystal *10",
    task98: "รับชมรวม 15 นาทีในวันที่ 8 ก.ย.",
    rewardTotal2: "Enchanting Coin Opt. Chest *2\nEnchanting Ticket *100",
    taskTotal2: "ทำภารกิจรับชมการแข่งขัน 2 รายการ",
    rewardTotal5: "Badge of Dusk *1  Gacha Ticket *5\n Super Pet Coupon *5",
    taskTotal5: "ทำภารกิจรับชมการแข่งขัน 5 รายการ",
    txt7: "ความคืบหน้า",
    txt8: "ยังไม่สำเร็จ",
    txt9: "รายละเอียด",
    txt10: "รับ",
    txt11: "已领取",
  },
  reward: [
    {
      type: "การแข่งขันแบบแพ้คัดออก",
      item: [
        {
          name: "อันดับที่ 1",
          image: require("@/assets/en-re1.png"),
          imageM: require("@/assets/mobile/en-re1.png"),
          list: [
            {
              name: "Thor Cup Champion Mount",
              amount: "",
            },
            {
              name: "Title: Thor Cup Champion (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Champion",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Champion",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "20000",
            },
            {
              name: "Diamond",
              amount: "5000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "10",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "30",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "40",
            },
            {
              name: "Crest of Moon",
              amount: "8",
            },
            {
              name: "King Statue Chest",
              amount: "10",
            },
          ],
        },
        {
          name: "อันดับที่ 2",
          image: require("@/assets/en-re2.png"),
          imageM: require("@/assets/mobile/en-re2.png"),
          list: [
            {
              name: "Title: Thor Cup 2nd Place (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup 2nd Place",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Runner-up",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "20",
            },
            {
              name: "Nyan Berry",
              amount: "10000",
            },
            {
              name: "Diamond",
              amount: "4500",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "10",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "25",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "36",
            },
            {
              name: "Crest of Moon",
              amount: "6",
            },
            {
              name: "King Statue Chest",
              amount: "8",
            },
          ],
        },
        {
          name: "อันดับที่\n 3-4",
          image: require("@/assets/en-re3.png"),
          imageM: require("@/assets/mobile/en-re3.png"),
          list: [
            {
              name: "Title: Thor Cup Top 4 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 4",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 4",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "17",
            },
            {
              name: "Nyan Berry",
              amount: "5000",
            },
            {
              name: "Diamond",
              amount: "4000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "8",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "20",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "32",
            },
            {
              name: "Crest of Moon",
              amount: "4",
            },
            {
              name: "King Statue Chest",
              amount: "6",
            },
          ],
        },
        {
          name: "อันดับที่\n 5-8",
          image: require("@/assets/en-re4.png"),
          imageM: require("@/assets/mobile/en-re4.png"),
          list: [
            {
              name: "Title: Thor Cup Top 8 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 8",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 8",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "15",
            },
            {
              name: "Nyan Berry",
              amount: "3000",
            },
            {
              name: "Diamond",
              amount: "3000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "6",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "15",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "28",
            },
            {
              name: "Crest of Moon",
              amount: "3",
            },
            {
              name: "King Statue Chest",
              amount: "4",
            },
          ],
        },
        {
          name: "อันดับที่\n 9-16",
          image: require("@/assets/en-re5.png"),
          imageM: require("@/assets/mobile/en-re5.png"),
          list: [
            {
              name: "Title: Thor Cup Top 16 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "7",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Diamond",
              amount: "2000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "4",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "10",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "24",
            },
            {
              name: "Crest of Moon",
              amount: "2",
            },
            {
              name: "King Statue Chest",
              amount: "2",
            },
          ],
        },
        {
          name: "อันดับที่\n 17-32",
          image: require("@/assets/en-re6.png"),
          imageM: require("@/assets/mobile/en-re6.png"),
          list: [
            {
              name: "Title: Thor Cup Top 32 (2024)",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Top 32",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "5",
            },
            {
              name: "Nyan Berry",
              amount: "1500",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "2",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "5",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "20",
            },
            {
              name: "Crest of Moon",
              amount: "1",
            },
            {
              name: "Diamond",
              amount: "1500",
            },
          ],
        },
      ],
    },
    {
      type: "การแข่งขันคะแนน",
      item: [
        {
          name: "อันดับ\n 4 แรก",
          image: require("@/assets/en-re7.png"),
          imageM: require("@/assets/mobile/en-re7.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "40",
            },
            {
              name: "Nyan Berry",
              amount: "2500",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "3",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "30",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "50",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "15",
            },

            {
              name: "Diamond",
              amount: "2500",
            },
          ],
        },
        {
          name: "อันดับที่\n 5-8",
          image: require("@/assets/en-re8.png"),
          imageM: require("@/assets/mobile/en-re8.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "35",
            },
            {
              name: "Nyan Berry",
              amount: "2300",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "3",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "25",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "45",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "13",
            },

            {
              name: "Diamond",
              amount: "2300",
            },
          ],
        },
        {
          name: "อันดับที่\n 9-16",
          image: require("@/assets/en-re9.png"),
          imageM: require("@/assets/mobile/en-re9.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "33",
            },
            {
              name: "Nyan Berry",
              amount: "2000",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "3",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "20",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "40",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "12",
            },

            {
              name: "Diamond",
              amount: "2000",
            },
          ],
        },
        {
          name: "อันดับที่\n 17-32",
          image: require("@/assets/en-re10.png"),
          imageM: require("@/assets/mobile/en-re10.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "30",
            },
            {
              name: "Nyan Berry",
              amount: "1900",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "3",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "19",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "38",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "11",
            },

            {
              name: "Diamond",
              amount: "1900",
            },
          ],
        },
        {
          name: "ทีมที่ไม่ได้เข้ารอบ",
          image: require("@/assets/en-re11.png"),
          imageM: require("@/assets/mobile/en-re11.png"),
          list: [
            {
              name: "Portrait: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Title: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Chat Bubble: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Portrait Frame: Thor Cup Elite",
              amount: "",
            },
            {
              name: "Champion Banner",
              amount: "28",
            },
            {
              name: "Nyan Berry",
              amount: "1800",
            },
            {
              name: "Optional Orange Sigil III",
              amount: "2",
            },
            {
              name: "Light-Dark Opt. Chest",
              amount: "18",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "36",
            },
            {
              name: "Opt. Statue Box (F)",
              amount: "10",
            },

            {
              name: "Diamond",
              amount: "1800",
            },
          ],
        },
        {
          name: "รางวัลเข้าร่วม",
          image: require("@/assets/en-re12.png"),
          imageM: require("@/assets/mobile/en-re12.png"),
          list: [
            {
              name: "Diamond",
              amount: "100",
            },
            {
              name: "Mark of Prowess",
              amount: "200",
            },
            {
              name: "Random Rare Sigil Gift Box",
              amount: "1",
            },
            {
              name: "Time-Space Opt. Chest",
              amount: "5",
            },
            {
              name: "Super Cookie",
              amount: "5",
            },
            {
              name: "Purple Feather Opt. Box",
              amount: "10",
            },
          ],
        },
      ],
    },
  ],
  dia: {
    txt1: "โค้ดรางวัล",
    txt2: "คัดลอก",
    txt3: "Copy successfully",
  },
};
